export default "__VITE_ASSET__DXZZE07v__"